// =============================================================================
// SERVICE ICON COMPONENT - SIMPLIFIED FONTICON ICONS
// =============================================================================

import React from 'react';

interface ServiceIconProps {
  icon: string;
  alt?: string;
  title?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  'aria-label'?: string;
  'aria-hidden'?: boolean;
}

export const ServiceIcon: React.FC<ServiceIconProps> = ({
  icon,
  alt = '',
  title,
  className = '',
  size = 'md',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = false,
}) => {
  // Ensure the icon has the proper fi class prefix
  const iconClass = icon.startsWith('fi ') ? icon : `fi ${icon}`;

  return (
    <i
      className={`${iconClass} service-icon service-icon--${size} ${className}`}
      aria-label={ariaLabel || alt}
      aria-hidden={ariaHidden}
      title={title}
    />
  );
};

export default ServiceIcon;
